<!-- src/components/SplashScreen.vue -->
<template>
  <div class="splash-screen">
    <div class="logo-container">
      <img src="@assets/logo_typo_full.png" alt="Noroo Logo" class="logo" />
    </div>
    <div class="logo-sub-container">
      <img src="@assets/logo_typo.png" alt="Noroo Sub Logo" class="logo-sub" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen'
}
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
  /* animation: fadeIn 0.5s ease-in-out; */
}

.logo {
  max-width: 180px;
  object-fit: contain;
}

.logo-sub-container {
  position: absolute;
  bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-sub {
  max-width: 80px;
  max-height: 80px;
  object-fit: contain;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
